module.exports = __webpack_public_path__ + "static/img/logoWhite.0712382.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integrations/primavera/logoWhite.svg
// module id = 3215
// module chunks = 0